import { render, staticRenderFns } from "./AmazonReturnsSyncPage.vue?vue&type=template&id=beb202a0&scoped=true"
import script from "./AmazonReturnsSyncPage.vue?vue&type=script&lang=js"
export * from "./AmazonReturnsSyncPage.vue?vue&type=script&lang=js"
import style0 from "./AmazonReturnsSyncPage.vue?vue&type=style&index=0&id=beb202a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb202a0",
  null
  
)

export default component.exports